export enum ECotationAction {
	cotation100 = "cotation100",
	cotation50 = "cotation50",
	cotation0 = "cotation0",
	excludeFromTaxAllowance = "excludeFromTaxAllowance"
}